exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".lp-setting[data-v-f0a85bca]{margin-bottom:32px!important}.lp-setting[data-v-f0a85bca]:last-child{margin-bottom:0!important}", ""]);

// exports
